export default __webpack_public_path__ + "static/media/src_img_10.a83c1a80.png";